import s from "./Sidebar.module.css";

const NAV_ITEMS = [
  {
    label: "Manage Lessons",
    mobileLabel: "Manage",
    key: "ManageLessons",
    icon: "M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    desktopOnly: true,
    adminOnly: true,
    adminBadge: true,
  },
  {
    label: "Admin Hub",
    key: "Monitor",
    icon: "M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5",
    desktopOnly: true,
    adminOnly: true,
    adminBadge: true,
  },
  {
    label: "AI Logs",
    key: "AiLogs",
    icon: "M8.625 12a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375M21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 0 1-2.555-.337A5.972 5.972 0 0 1 5.41 20.97a5.969 5.969 0 0 1-.474-.065 4.48 4.48 0 0 0 .978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25Z",
    desktopOnly: true,
    adminOnly: true,
    adminBadge: true,
  },
  {
    label: "Lessons",
    key: "History",
    icon: "M2.25 12l8.954-8.955a1.126 1.126 0 0 1 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25",
  },
  {
    label: "AI Tutor",
    key: "AiTutor",
    icon: "M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 0 0-2.455 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z",
  },
  {
    label: "Translation",
    key: "Sentences",
    icon: "m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3M12.334 5.364a48.11 48.11 0 0 1 3.413.263M15.747 5.627a40.42 40.42 0 0 1-3.413-.263m0 0A42.18 42.18 0 0 0 9 5.25m3.334.114A49.5 49.5 0 0 1 15 9.75",
  },
  {
    label: "Profile",
    key: "Profile",
    icon: "M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z",
  },
  {
    label: "Support",
    key: "Support",
    icon: "M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75",
  },
];

export default function Sidebar({ activeTab = "History", onTabChange, onLogout, collapsed = false, onToggle, userEmail, userRole, supportUnreadCount = 0 }) {
  const isAdmin = userRole === "admin";
  const visibleItems = isAdmin ? NAV_ITEMS : NAV_ITEMS.filter((item) => !item.adminOnly);

  return (
    <nav className={`${s.sidebar} ${collapsed ? s.collapsed : ""}`}>
      <div className={s.logo}>
        <span className={s.logoText}>{collapsed ? "Ts" : "Tala svenska"}</span>
      </div>

      <div className={s.nav}>
        {visibleItems.map((item) => (
          <button
            key={item.key}
            className={`${s.navItem} ${item.key === activeTab ? s.active : ""} ${item.desktopOnly ? s.desktopOnly : ""}`}
            onClick={() => onTabChange?.(item.key)}
            title={collapsed ? item.label : undefined}
          >
            {item.imgSrc ? (
              <img className={s.navIcon} src={item.imgSrc} alt="" />
            ) : (
              <svg
                className={s.navIcon}
                viewBox={item.viewBox || "0 0 24 24"}
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d={item.icon} />
              </svg>
            )}
            <span className={s.navLabelWrap}>
              <span className={s.navLabel}>{item.label}</span>
              {item.adminBadge && !collapsed && <span className={s.adminBadge}>admin</span>}
              {item.key === "Support" && supportUnreadCount > 0 && !collapsed && (
                <span className={s.countBadge}>{supportUnreadCount} new</span>
              )}
            </span>
            <span className={s.navLabelMobile}>
              {item.mobileLabel || item.label}
              {item.key === "Support" && supportUnreadCount > 0 && (
                <span className={s.countBadgeMobile}>{supportUnreadCount}</span>
              )}
            </span>
            {item.key === "Support" && supportUnreadCount > 0 && collapsed && (
              <span className={s.countDot} />
            )}
          </button>
        ))}
      </div>

      <div className={s.bottom}>
        <button className={s.navItem} onClick={onLogout} title={collapsed ? "Logout" : undefined}>
          <svg
            className={s.navIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9" />
          </svg>
          <span className={s.navLabel}>Logout</span>
        </button>
      </div>

      {/* Toggle button */}
      <button
        className={s.toggle}
        onClick={onToggle}
        title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
        aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          {collapsed
            ? <path d="M9 18l6-6-6-6" />
            : <path d="M15 18l-6-6 6-6" />}
        </svg>
      </button>
    </nav>
  );
}
